import {styled,Box} from "@mui/material"

export const Icons =  styled(Box)(({theme})=>({
    display:"flex",
    gap:"20px",
    alignItems:"center"
}))